const statuses = [
  {
    name: 'pending',
    description: 'Ожидается',
  },
  {
    name: 'approved',
    description: 'Одобрено',
  },
  {
    name: 'rejected',
    description: 'Отклонено',
  },
];

export default {
  get() {
    return statuses;
  },
  getByName(name) {
    return statuses.filter(status => status.name == name);
  },
  getByDescription(description) {
    return statuses.filter(status => status.description == description);
  },
};
